import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useContext, createContext, lazy } from "react";
import { AuthorisationContext } from "@sal/authentication.react";
import { PublicClientApplication } from "@azure/msal-browser";
const MsalProvider = lazy(() => import("@azure/msal-react").then((module) => ({ default: module.MsalProvider })));
const authSettings = {
    servicePath: "/PortalFramework/Account/",
};
var defaultContextState = {
    settings: {},
    colorMode: "light",
    setColorMode: () => console.error("no context provider"),
};
const portalFrameworkContext = createContext(defaultContextState);
function setup(s) {
    const [settings] = useState(s);
    // const cm: ColorMode = localStorage.getItem("colorMode") as ColorMode || settings.defaultColorMode || "light";
    const cm = settings.defaultColorMode || "light";
    const [colorMode, setColorMode] = useState(cm);
    console.debug("PortalFramework.setup", { settings, colorMode });
    return {
        settings,
        colorMode,
        setColorMode,
    };
}
export const usePortalFramework = () => {
    return useContext(portalFrameworkContext);
};
export function PortalFramework(props) {
    var _a;
    const instance = setup(props.settings);
    const authContext = _jsx(AuthorisationContext, { settings: authSettings, children: props.children });
    let tags;
    if ((_a = props.settings.microsoftSsoSettings) === null || _a === void 0 ? void 0 : _a.enableSso) {
        const config = {
            auth: {
                clientId: props.settings.microsoftSsoSettings.clientID,
                authority: props.settings.microsoftSsoSettings.authority,
                redirectUri: props.settings.microsoftSsoSettings.redirectUrl,
            },
            cache: {
                cacheLocation: "sessionStorage",
                storeAuthStateInCookie: false
            }
        };
        const publicClientApplication = new PublicClientApplication(config);
        tags =
            _jsx(MsalProvider, { instance: publicClientApplication, children: authContext });
    }
    else {
        tags = authContext;
    }
    return (_jsx(portalFrameworkContext.Provider, { value: instance, children: tags }));
}
